<template>
  <div id="imageDownload">
    <v-container class="pa-0">
      <v-layout>
        <v-flex class="xs12 sm12 mb-5">
          <v-btn fab absolute left :to="{ path: '/albums'}" class="ml-3 pf-btn-fab">
            <v-icon>arrow_back</v-icon>
          </v-btn>            
        </v-flex>
      </v-layout>
    </v-container>
    <div style="min-height:50px;">
        
        <div style="float:right" v-show="selected.length">
          <v-btn class="pf-btn pf-btn-cancel" @click="selected = []">
            <v-icon size="16" class="pr-1">cancel</v-icon>
            <div>Cancel</div>
          </v-btn>
          <v-btn class="pf-btn pf-btn-save" @click="downloadSelected">
            <v-icon size="16" class="pr-1">check_circle</v-icon>
            <div>Download</div>
          </v-btn>
        </div>
      </div>
    <v-card>
      
      <v-data-table :items="PhotoDownload" class="pf-data-table" hide-actions>
        <template v-slot:items="props">
          <tr>
            <td colspan="6" v-if="props.item.name">
              <b>{{ props.item.name }}</b>
            </td>
          </tr>
          <tr v-show="!props.item.photo.length"><td colspan="5">No photos found</td></tr>
          <template v-for="(it, i) in props.item.photo">
            <tr v-if="it.photo" :key="it.photo._id || i">
              <td>
                <v-checkbox primary hide-details v-model="selected" multiple :value="it.photo.original_url || it.photo.webview_url || it.photo.thumb_url"></v-checkbox>
              </td>
              <td>
                <img :src="it.photo.thumb_url" alt="Image" height="100px" />
              </td>
              <td>
                <a :href="it.photo.original_url || it.photo.webview_url || it.photo.thumb_url" target="_blank">Image Link</a>
              </td>
              <td>{{ Math.round(it.photo.size/ 1024) }} KB</td>
              <td>{{ formatDateMethod(it.photo.createdAt)}}</td>
            </tr>
          </template>
        </template>
      </v-data-table>
    </v-card>
    <div style="min-height:50px;" class="pt-2">
        
        <div style="float:right" v-show="selected.length">
          <v-btn class="pf-btn pf-btn-cancel" @click="selected = []">
            <v-icon size="16" class="pr-1">cancel</v-icon>
            <div>Cancel</div>
          </v-btn>
          <v-btn class="pf-btn pf-btn-save" @click="downloadSelected">
            <v-icon size="16" class="pr-1">check_circle</v-icon>
            <div>Download</div>
          </v-btn>
        </div>
      </div>
  </div>
</template>
<script>
import swal from 'sweetalert2';
import { getCollection, sortList, formatDate } from '../helpers/helpers';
import JsZip from 'jszip';
import JSZipUtils from 'jszip-utils';
import { saveAs } from 'file-saver';
/* global session store */
export default {
  data: () => ({
    selected: [],
    album: '',
    headers: [
      { text: '', sortable: false, width: '70px' },
      { text: 'Image', value: 'image', align: 'left', sortable: false },
      { text: 'Image Link', value: 'imageLink', sortable: false },
      { text: 'Size', value: 'status', sortable: false },
      { text: 'Created Date', value: 'createdDate' }
    ],
    itemData: [
      {
        sub: true,
        name: 'Album 1',
        items: [
          {
            id: '1',
            albumId: '11',
            image: 'https://picsum.photos/400?image=15',
            imageLink: 'https://picsum.photos/400?image=15',
            imageSize: '650 kb',
            createdDate: '01/20/2018',
            selectedimages: false
          },
          {
            id: '2',
            albumId: '11',
            image: 'https://picsum.photos/400?image=25',
            imageLink: 'https://picsum.photos/400?image=25',
            imageSize: '550 kb',
            createdDate: '01/20/2018',
            selectedimages: false
          },
          {
            id: '3',
            albumId: '11',
            image: 'https://picsum.photos/400?image=35',
            imageLink: 'https://picsum.photos/400?image=35',
            imageSize: '450 kb',
            createdDate: '01/20/2018',
            selectedimages: false
          },
          {
            id: '4',
            albumId: '11',
            image: 'https://picsum.photos/400?image=45',
            imageLink: 'https://picsum.photos/400?image=45',
            imageSize: '350 kb',
            createdDate: '01/20/2018',
            selectedimages: false
          },
          {
            id: '5',
            albumId: '11',
            image: 'https://picsum.photos/400?image=55',
            imageLink: 'https://picsum.photos/400?image=55',
            imageSize: '250 kb',
            createdDate: '01/20/2018',
            selectedimages: false
          },
          {
            id: '6',
            albumId: '11',
            image: 'https://picsum.photos/400?image=65',
            imageLink: 'https://picsum.photos/400?image=65',
            imageSize: '50 kb',
            createdDate: '01/20/2018',
            selectedimages: false
          },
          {
            id: '7',
            albumId: '12',
            image: 'https://picsum.photos/400?image=75',
            imageLink: 'https://picsum.photos/400?image=75',
            imageSize: '150 kb',
            createdDate: '04/12/2018',
            selectedimages: false
          }
        ]
      },
      {
        sub: true,
        name: 'Album 2',
        items: [
          {
            id: '8',
            albumId: '11',
            image: 'https://picsum.photos/400?image=15',
            imageLink: 'https://picsum.photos/400?image=15',
            imageSize: '650 kb',
            createdDate: '01/20/2018',
            selectedimages: false
          },
          {
            id: '9',
            albumId: '11',
            image: 'https://picsum.photos/400?image=25',
            imageLink: 'https://picsum.photos/400?image=25',
            imageSize: '550 kb',
            createdDate: '01/20/2018',
            selectedimages: false
          },
          {
            id: '10',
            albumId: '11',
            image: 'https://picsum.photos/400?image=35',
            imageLink: 'https://picsum.photos/400?image=35',
            imageSize: '450 kb',
            createdDate: '01/20/2018',
            selectedimages: false
          },
          {
            id: '11',
            albumId: '11',
            image: 'https://picsum.photos/400?image=45',
            imageLink: 'https://picsum.photos/400?image=45',
            imageSize: '350 kb',
            createdDate: '01/20/2018',
            selectedimages: false
          }
        ]
      },
      {
        sub: true,
        name: 'Album 3',
        items: [
          {
            id: '12',
            albumId: '11',
            image: 'https://picsum.photos/400?image=15',
            imageLink: 'https://picsum.photos/400?image=15',
            imageSize: '650 kb',
            createdDate: '01/20/2018',
            selectedimages: false
          },
          {
            id: '13',
            albumId: '11',
            image: 'https://picsum.photos/400?image=25',
            imageLink: 'https://picsum.photos/400?image=25',
            imageSize: '550 kb',
            createdDate: '01/20/2018',
            selectedimages: false
          },
          {
            id: '14',
            albumId: '12',
            image: 'https://picsum.photos/400?image=75',
            imageLink: 'https://picsum.photos/400?image=75',
            imageSize: '150 kb',
            createdDate: '04/12/2018',
            selectedimages: false
          }
        ]
      }
    ]
  }),
  computed: {
    albumList: {
      get () {
        return store.state.Album;
      }
    },
    PhotoDownload: {
      set (value) {
        store.commit('setPhotoDownload', value);
      },
      get () {
        return store.state.PhotoDownload;
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  created () {
    this.initialize();
  },
  methods: {
    async initialize () {
      // if (!this.PhotoDownload.length) {
      let entity = 'Album';
      let sessionUser = session.getSession();
      let where = sessionUser.adminUser ? { account: sessionUser.user.human.account.id } : {};
      let { error, data } = await getCollection(entity, true, 0, ['photo.photo'], where);
      if (error) {
        console.log('error', error);
      } else {
        if (data.length > 0) {
          this.PhotoDownload = sortList(entity, data, 'Account', sessionUser.adminUser ? sessionUser.user.human.account.id : 'Me');
        }
      }
      // }
    },
    downloadSelected () {
      this.downloadAlbum(this.selected);
    },
    async downloadAlbum (urls) {
      this.selected = [];
      let zip = new JsZip();
      let count = 0;
      let zipName = 'selected.zip';
      if (urls.length !== 0) {
        urls.forEach(function (url) {
          let filename = url.substring(url.lastIndexOf('/') + 1);
          if (url) {
            let hostHttps = window.location.origin.indexOf('https');
            let newUrl = '';
            if (hostHttps === -1) {
              newUrl = url.replace('https', 'http');
            }
            else {
              newUrl = url;
            }
            JSZipUtils.getBinaryContent(newUrl, function (err, data) {
              if (err) {
                throw err; // or handle the error
              }
              zip.file(filename, data, { binary: true });
              count++;
              if (count === urls.length) {
                swal.fire({
                  type: 'success',
                  title: 'Your album is downloading, Please wait...',
                  showConfirmButton: false,
                  timer: 2500,
                  onClose: () => {
                    //
                  }
                });
                zip.generateAsync({ type: 'blob' }).then(function (content) {
                  saveAs(content, zipName);
                  
                });
                
              }
            });
          }
        });
      }
      else {
        swal.fire({
          type: 'warning',
          title: 'No photos selected to download',
          showConfirmButton: false,
          timer: 2500,
          onClose: () => {
            //
          }
        });
      }
    },
    formatDateMethod (date) {
      return formatDate(date, 'MM/DD/YYYY');
    },
  }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/ImageDownload.vue